import Vue from 'vue';
import Router from 'vue-router';
import Auth from '@/auth';
import AdvancedSearch from '@/views/AdvancedSearch.vue';
import Contact from '@/views/Contact.vue';
import EditProject from '@/views/EditProject.vue';
import Home from '@/views/Home.vue';
import NotAuthorized from '@/views/NotAuthorized.vue';
import NewInstrument from '@/views/NewInstrument.vue';
import NewMultiPropService from '@/views/NewMultiPropService.vue';
import NewProject from '@/views/NewProject.vue';
import NewProperty from '@/views/NewProperty.vue';
import NewService from '@/views/NewService.vue';
import Project from '@/views/Project.vue';
import ProjectInstruments from '@/views/ProjectInstruments.vue';
import ProjectProperties from '@/views/ProjectProperties.vue';
import ProjectService from '@/views/ProjectService.vue';
import ProjectServices from '@/views/ProjectServices.vue';
import ProjectSummary from '@/views/ProjectSummary.vue';
import ProjectSearch from '@/views/ProjectSearch.vue';
import SignedOut from '@/views/SignedOut.vue';
import ViewOnly from '@/views/ViewOnly.vue';
import InstrumentTags from '@/views/InstrumentTags.vue';
import store from '@/store/store';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/signedout',
      name: 'signedout',
      component: SignedOut,
    },
    {
      path: '/instrumentTags',
      name: 'instrument tags',
      component: InstrumentTags,
    },
    {
      path: '/notauthorized',
      name: 'not authorized',
      component: NotAuthorized,
    },
    {
      path: '/viewonly',
      name: 'view only',
      component: ViewOnly,
    },
    {
      path: '/authorized',
      name: 'authorized',
    },
    {
      path: '/contact/:id',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/project/new',
      name: 'new project',
      component: NewProject,
      beforeEnter: (to, from, next) => {
        if (store.getters['User/isCurrentUserViewOnly']) {
          next('viewOnly');
        } else {
          next();
        }
      },
    },
    {
      path: '/service/newMultiProperty',
      name: 'New Multi-Property Service',
      component: NewMultiPropService,
      beforeEnter: (to, from, next) => {
        if (store.getters['User/isCurrentUserViewOnly']) {
          next('viewOnly');
        } else {
          next();
        }
      },
    },
    {
      path: '/search',
      name: 'Advanced Search',
      component: AdvancedSearch,
    },
    {
      path: '/projectSearch',
      name: 'Project Search',
      component: ProjectSearch,
    },
    {
      path: '/project/:project_id',
      component: Project,
      children: [
        {
          name: 'project',
          path: '',
          component: ProjectSummary,
        },
        {
          name: 'newInstrument',
          path: 'instruments/new',
          component: NewInstrument,
          beforeEnter: (to, from, next) => {
            if (store.getters['User/isCurrentUserViewOnly']) {
              next('viewOnly');
            } else {
              next();
            }
          },
        },
        {
          name: 'projectInstruments',
          path: 'instruments',
          component: ProjectInstruments,
          children: [
            {
              name: 'projectInstrument',
              path: ':id',
              component: ProjectInstruments,
            },
          ],
        },
        {
          name: 'newProperty',
          path: 'properties/new',
          component: NewProperty,
          beforeEnter: (to, from, next) => {
            if (store.getters['User/isCurrentUserViewOnly']) {
              next('viewOnly');
            } else {
              next();
            }
          },
        },
        {
          name: 'projectProperties',
          path: 'properties',
          component: ProjectProperties,
          children: [
            {
              name: 'projectProperty',
              path: ':property_id',
              component: ProjectProperties,
            },
          ],
        },
        {
          name: 'newService',
          path: 'services/new',
          component: NewService,
          beforeEnter: (to, from, next) => {
            if (store.getters['User/isCurrentUserViewOnly']) {
              next('viewOnly');
            } else {
              next();
            }
          },
        },
        {
          name: 'projectServices',
          path: 'services',
          component: ProjectServices,
          children: [
            {
              name: 'projectService',
              path: ':id',
              component: ProjectService,
            },
          ],
        },
      ],
    },
    {
      name: 'edit project',
      path: '/project/:project_id/edit',
      component: EditProject,
      beforeEnter: (to, from, next) => {
        if (store.getters['User/isCurrentUserViewOnly']) {
          next('viewOnly');
        } else {
          next();
        }
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  Auth.initialize(store).then(() => {
    if (to.name === 'signedout' || to.name === 'not authorized' || to.name === 'authorized') {
      next();
    } else {
      Auth.clientApplication.acquireTokenSilent([Auth.config.clientId])
        .then(() => next(),
          () => Auth.clientApplication.loginPopup().then(() => {
            store.dispatch('User/setUser', Auth.clientApplication.getUser()).then(() => {
              next();
            });
          }, (error) => {
            /*  Promise rejection does not make a proper JS object available, it only returns a
                string. This error code happens when the user belongs to the tenant, but has not
                been added to the Terratrac app registration.
            */
            if (error.includes('AADSTS50105')) {
              // Still log the error to the console, but continue to not authorized page.
              console.error(error);
              return Promise.resolve(next({ path: '/notauthorized' }));
            }
            return Promise.reject(error);
          }));
    }
  });
});

Vue.use(Router);

export default router;
